import { Box, IconButton, Tooltip } from "@mui/material";
import { ClearAllRounded, MenuRounded } from "@mui/icons-material";
import {
  ConversionListViewer,
  QueryParam,
  Mode,
  Freshness,
} from "../../general";
import { useResetDashboardSettings } from "../../../../hooks";

const Forgotten = ({ toggleDrawer, isDrawerExpandedMatch }) => {
  const reset = useResetDashboardSettings();

  const {
    executeSettingsReset,
    settingsResetExecuted,
    showResetIcon,
    setShowResetIcon,
    resetSettingsHandle,
  } = reset;

  return (
    <Box sx={{ ml: 2, mr: 2 }}>
      <ConversionListViewer
        reset={{
          executeSettingsReset,
          settingsResetExecuted,
          setShowResetIcon,
        }}
        settingsTopBar={
          <ForgottenTopBar
            isDrawerExpandedMatch={isDrawerExpandedMatch}
            toggleDrawer={toggleDrawer}
            reset={{
              showResetIcon,
              resetSettingsHandle,
            }}
          />
        }
        conversionRowOptions={{
          highlightBorderBottom: false,
          withDelete: true,
          dateSettings: {
            title: "Date of forgetting",
            field: "markedAt",
          },
        }}
        withViewSwitcher={false}
        fixedFilters={{
          [QueryParam.mode]: Mode.HISTORY,
          [QueryParam.FRESHNESS]: Freshness.FORGOTTEN,
        }}
      />
    </Box>
  );
};

const ForgottenTopBar = ({ isDrawerExpandedMatch, toggleDrawer, reset }) => {
  const { showResetIcon, resetSettingsHandle } = reset;
  return (
    <Box sx={{ mt: 1, mb: 1, pt: 1, display: "flex", alignItems: "center" }}>
      {!isDrawerExpandedMatch && (
        <Box sx={{ pl: 2 }}>
          <IconButton onClick={toggleDrawer(true)}>
            <MenuRounded fontSize="large" />
          </IconButton>
        </Box>
      )}
      <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box>
            <h1>Forgotten</h1>
          </Box>
          {showResetIcon && (
            <Box>
              <Tooltip title="Reset filters" placement="right">
                <IconButton onClick={resetSettingsHandle}>
                  <ClearAllRounded />
                </IconButton>
              </Tooltip>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default Forgotten;